var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center book-loader",class:{'overlay': _vm.overlay, 'modal': _vm.overlay && _vm.modal}},[_c('div',{staticClass:"cssload-container",class:{'small': _vm.small}},[_c('div',{staticClass:"cssload-zenith",class:{'cssload-zenith-white': _vm.white}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }